
import { motion } from 'framer-motion'
import loginSide from '../../Assets/Images/loginSide.png'
import FieldInput from '../../Components/FieldInput'
import * as Yup from 'yup'
import { useFormik } from "formik"
import Button from "../../Components/Button"
import { FiLock, FiLogIn, FiMessageSquare } from "react-icons/fi";
import { useHistory } from "react-router-dom"
import API from "../../Common/API"
import { useDispatch } from "react-redux"
import { setAlert } from "../../Store/Theme/actions"
import logo from '../../Assets/Images/logo.png'
import { useTranslation } from "react-i18next"
import React,{useState} from 'react'

const initialLoginForm = {
    mobileNumber:'',
}

const initialOTPForm = {
    otp:'',    
}

const initialPasswordForm = {
    newPassword:'',
    confirmPassword:''
}

const ForgotPassword = () => {


    const history = useHistory()
    const dispatch = useDispatch();
    const { t } = useTranslation()
    const [otpFormEnable,setOtpFormEnable] = useState(false)
    const [passwordFormEnable,setPasswordFormEnable] = useState(false)
    const [submitButtonDisabled,setSubmitButtonDisabled] = useState(false)

    const forgotFormSchema = Yup.object().shape({
        mobileNumber: Yup.string().required("Mobile Number is required"),
    })

    const otpFormSchema = Yup.object().shape({
        otp: Yup.string().required("OTP is required"),
    })

    const passwordFormSchema = Yup.object().shape({
        newPassword: Yup.string().required("New Password is required"),
        confirmPassword: Yup.string().oneOf([Yup.ref('newPassword'), null], 'Passwords must match').required('Confirm Password is required'),
    })

    const otpForm = useFormik({
        initialValues: initialOTPForm,
        validateOnMount: true,
        validationSchema: otpFormSchema,
        enableReinitialize: true,
        onSubmit: (values) => {
            console.log(values)
            values.mobileNumber = forgotForm.values.mobileNumber
            try {
               API.post('/auth/verifyPassOTP',values).then((res)=>{
                if(res.status === 200){
                    dispatch(setAlert({subtitle: res.data.message,type:'success',active:true }))
                    setOtpFormEnable(false)
                    setPasswordFormEnable(true)
                }
               }).catch((err)=>{
                if(err.response){
                    dispatch(setAlert({subtitle: err.response.data.error.message, type:'error',active:true }))
                }
               })
            } catch (err) {
                console.log(err)
            }
        }
    })

    const passwordForm = useFormik({
        initialValues: initialPasswordForm,
        validateOnMount: true,
        validationSchema: passwordFormSchema,
        enableReinitialize: true,
        onSubmit: (values) => {
            try {
                API.post('/auth/changePassword', {...values, mobileNumber: forgotForm.values.mobileNumber}).then((res)=>{
                    if(res.status === 200){
                        dispatch(setAlert({subtitle: "Password reset successful.",type:'success',active:true }))
                        setPasswordFormEnable(false)
                        setOtpFormEnable(false)
                        history.push('/auth/login')
                    }
                }).catch((err)=>{
                    if(err.response){
                        dispatch(setAlert({subtitle: err.response.data.error.message, type:'error',active:true }))
                    }
                })
            } catch (err) {
                console.log(err)
            }
        }
    })

    const forgotForm = useFormik({
        initialValues: initialLoginForm,
        validateOnMount: true,
        validationSchema: forgotFormSchema,
        enableReinitialize: true,
        onSubmit: (values) => {
            try {
                setSubmitButtonDisabled(true)
                API.post('/auth/requestOTP',values).then((res)=>{
                    if(res.status === 200){
                        dispatch(setAlert({subtitle: "OTP sent to your registered mobile number",type:'success',active:true }))
                        setOtpFormEnable(true)
                        setSubmitButtonDisabled(false)
                    }
                }).catch((err)=>{
                    if(err.response){
                        dispatch(setAlert({subtitle: err.response.data.error.message, type:'error',active:true }))
                    }
                })
            } catch (err) {
                console.log(err)
            }
        }
    })

    return (
        <motion.div className="min-h-screen w-full flex flex-col">
            <motion.div className="h-full w-full flex flex-row justify-between gap-2">
                <div className="w-full lg:w-1/2 flex flex-col justify-center items-start py-5 md:py-0 lg:px-20">
                    <h1 className="text-2xl font-bold text-primeColor mb-4 px-5">{t('Forgot Password!')}</h1>
                    <p className="text-black mb-6 px-5">{t('Enter your registered mobile number to get the OTP!')}</p>
                    <motion.div className="grid grid-cols-1 w-full gap-5">
                        {!otpFormEnable && !passwordFormEnable && <motion.div className='flex flex-col'>
                            <FieldInput outerInjectClass={'w-full'} length={10} label={t('Mobile Number')} fieldProps={forgotForm.getFieldProps('mobileNumber')} fieldHelper={forgotForm.getFieldHelpers('mobileNumber')} fieldMeta={forgotForm.getFieldMeta('mobileNumber')} edit={true} dataLoaded={true} />
                        <Button disabled={submitButtonDisabled} type="primary" injectClass={'flex items-center text-center justify-center flex-row w-full'} onClick={() => forgotForm.submitForm()}>
                            <FiMessageSquare /> &nbsp;{t('Send OTP')}</Button>
                        </motion.div>}
                        {otpFormEnable && <motion.div className='flex flex-col'>
                            <FieldInput outerInjectClass={'w-full'} type='password' label={t('OTP')} fieldProps={otpForm.getFieldProps('otp')} fieldHelper={otpForm.getFieldHelpers('otp')} fieldMeta={otpForm.getFieldMeta('otp')} edit={true} dataLoaded={true} />
                        <Button disabled={submitButtonDisabled} type="primary" injectClass={'flex items-center text-center justify-center flex-row w-full'} onClick={() => otpForm.submitForm()}>
                            <FiLock /> &nbsp;{t('Verify OTP')}</Button>
                        </motion.div>}
                        {passwordFormEnable && <motion.div className='flex flex-col'>
                            <FieldInput outerInjectClass={'w-full'} type='password' label={t('New Password')} fieldProps={passwordForm.getFieldProps('newPassword')} fieldHelper={passwordForm.getFieldHelpers('newPassword')} fieldMeta={passwordForm.getFieldMeta('newPassword')} edit={true} dataLoaded={true} />
                            <FieldInput outerInjectClass={'w-full'} type='password' label={t('Confirm Password')} fieldProps={passwordForm.getFieldProps('confirmPassword')} fieldHelper={passwordForm.getFieldHelpers('confirmPassword')} fieldMeta={passwordForm.getFieldMeta('confirmPassword')} edit={true} dataLoaded={true} />
                        <Button disabled={submitButtonDisabled} type="primary" injectClass={'flex items-center text-center justify-center flex-row w-full'} onClick={() => passwordForm.submitForm()}>
                            <FiLogIn /> &nbsp;{t('Reset Password')}</Button>
                        </motion.div>}
                        <motion.div className="flex flex-row w-full justify-start px-2">
                            <motion.div className="bg-[green] text-white px-4 py-1 rounded-full font-bold cursor-pointer" onClick={() => history.push('/auth/login')}>
                                <p>{t('Return to login')}</p>
                            </motion.div>
                        </motion.div>
                    </motion.div>
                </div>
                <div className="hidden lg:flex w-1/2 h-screen relative">
                    <img
                        src={loginSide}
                        alt="Login Side"
                        className="w-full h-full object-cover"
                    />
                    <div className="absolute bottom-4 left-4 w-full items-center justify-center flex flex-col rounded-md  p-4">
                        <div className="bg-primeColor w-fit px-2 py-2">
                            <img src={logo} />
                        </div>
                        <p className="text-gray-700">{t('Kallar thirumana sevai')}</p>
                    </div>
                </div>
            </motion.div>
        </motion.div>
    )
}

export default ForgotPassword